import {
  DataPointValue,
  IMeasureMetadata,
  type MeasureFormatter,
} from '@principle-theorem/principle-core/interfaces';

// TODO: Remove use of this as scope is determinant on RBAC and user-defined grouping
export enum MeasureType {
  Organisation = 'Organisation',
  Practice = 'Practice',
  Brand = 'Brand',
  Patient = 'Patient',
  Practitioner = 'Practitioner',
  Referrer = 'Referrer',
  Time = 'Date',
}

export interface IChartContents {
  dataHeaders: string[];
  dataPoints: IChartDataPoint[];
}

export interface IChartDataPoint {
  label: string | Date; // label is generally the date (won't be the case for bar graphs)
  values: IDataPoint[];
}

export interface IDataPoint {
  label: string;
  value: DataPointValue;
  valueLabel?: string;
  formatter?: MeasureFormatter;
  formatterValue?: IMeasureMetadata['formatterValue'];
  /**
   * Personally Identifiable Information (PII) — data that can identify a
   * specific individual, such as names, emails, phone numbers, or dates of
   * birth. When true, the value will be obfuscated in Marketing Mode.
   */
  isPii?: boolean;
  /**
   * The type of PII obfuscation to apply when `isPii` is true.
   * Determines which fake-data generator is used. Defaults to `'name'`.
   */
  piiType?: IMeasureMetadata['piiType'];
}
